import React, { useEffect, useState } from "react";
import ImageGallery from "react-image-gallery";
import Fade from "react-reveal/Fade";
import {
  isGoogleDriveSliderConfigured,
  listGoogleDriveSliderImages,
} from "../../api/googleDriveSlider";

function ImageSlider() {
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [captionIndex, updateCaptionIndex] = useState(0);

  useEffect(() => {
    let active = true;

    if (!isGoogleDriveSliderConfigured()) {
      setIsLoading(false);
      return () => {
        active = false;
      };
    }

    listGoogleDriveSliderImages()
      .then((driveImages) => {
        if (active) {
          setImages(driveImages);
          updateCaptionIndex(0);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error(
          "Unable to load the homepage photos from Google Drive:",
          error
        );
        if (active) {
          setIsLoading(false);
        }
      });

    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    if (captionIndex >= images.length) {
      updateCaptionIndex(0);
    }
  }, [captionIndex, images.length]);

  return (
    <section className="image-slider">
      <h3 className="section-title">Photos</h3>
      {images.length ? (
        <>
          <Fade>
            <ImageGallery
              items={images}
              showThumbnails={false}
              showFullscreenButton={false}
              showPlayButton={false}
              autoPlay={true}
              slideDuration={0}
              slideInterval={7000}
              onBeforeSlide={updateCaptionIndex}
            />
          </Fade>
          <Fade bottom>
            <p className="caption">{images[captionIndex]?.originalAlt}</p>
          </Fade>
        </>
      ) : !isLoading ? (
        <p className="caption">Photos are currently unavailable.</p>
      ) : null}
    </section>
  );
}

export default ImageSlider;
